export default __webpack_public_path__ + "media/images/logo/media/bs_asahi-0ac1691bfb81ae4c643297cf987238fa.jpg";